import { Box, Card, Grid, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useGetAllAssetsQuery } from '../../../../app/Slices/SevenDayApiSlice';
import ExperiencesListAll from '../../Experiences/ExperiencesListAll';
import { availability } from './AIGuestReservationAssistant';
import AIHistoryAvailabilityTable from './AIHistoryAvailabilityTable';

export default function AIHistoryChatComponent({ data }: any) {
    const { data: allExperiences, isFetching: isFetchingExperiences } =
        useGetAllAssetsQuery({
            url: '/modules',
            sort: 'name',
        });

    const showExperiencesList = (message: any): boolean => {
        const result =
            message.message
                .toLowerCase()
                .includes(
                    'please tell us which experience you would like to reserve? Here are the options based on your filters'.toLowerCase(),
                ) ||
            ['here are the available', 'here is the available'].some((word) =>
                message.message.toLowerCase().includes(word),
            );

        return result;
    };

    const theme = useTheme();

    const messages = data?.messages.map((message: any) => {
        const updatedMessage = {
            ...message,
            renderMessage: true,
            experiences: allExperiences?.filter((experience) =>
                message.message
                    .toLowerCase()
                    .includes(experience.name.toLowerCase()),
            ),
        };

        if (showExperiencesList(updatedMessage)) {
            updatedMessage.message =
                'Please tell us which experience you would like to reserve? Here are the options based on your filters.';
        }

        if (updatedMessage.message.includes('bookingInfo')) {
            updatedMessage.message = updatedMessage.message.replace(/,/g, ', ');
        }

        return updatedMessage;
    });

    if (messages?.[0]?.sender === 'user' && messages.length > 1) {
        [messages[0], messages[1]] = [messages[1], messages[0]];
    }

    return (
        <Grid
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Stack
                spacing={2}
                flex={1}
                sx={{
                    paddingTop: '50px',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    width: '100%',
                    pr: 1,
                    paddingBottom: '50px',
                }}
            >
                {messages?.map((message: any, i: any) => {
                    return (
                        <Box
                            display='flex'
                            flexDirection='column'
                            width='100%'
                            alignSelf={
                                message?.sender === 'user'
                                    ? 'flex-end'
                                    : 'flex-start'
                            }
                            alignItems={
                                message?.sender === 'user'
                                    ? 'flex-end'
                                    : 'flex-start'
                            }
                        >
                            {message.renderMessage !== false && (
                                <>
                                    <Box
                                        id='messages'
                                        bgcolor={
                                            message?.sender === 'user'
                                                ? theme.palette.info.main
                                                : theme.palette.neutral.main
                                        }
                                        borderRadius={2}
                                        p={2}
                                        color={
                                            message?.sender === 'user'
                                                ? 'white'
                                                : 'black'
                                        }
                                        sx={{
                                            maxWidth: '70%',
                                        }}
                                    >
                                        <Typography
                                            color={
                                                message?.sender === 'user'
                                                    ? 'white'
                                                    : theme.palette.midGrey.main
                                            }
                                            sx={{
                                                whiteSpace: 'pre-line',
                                            }}
                                        >
                                            {' '}
                                            {showExperiencesList(message) &&
                                            message?.experiences &&
                                            message?.experiences?.length ===
                                                0 &&
                                            !isFetchingExperiences
                                                ? 'No experiences match your filters. Try adjusting your criteria to see more options.'
                                                : availability(message)
                                                        .showTable &&
                                                    availability(message)
                                                        .availabilityCount === 1
                                                  ? `${
                                                        JSON.parse(
                                                            message.message,
                                                        ).availability[0].reason
                                                    } ${
                                                        availability(message)
                                                            .showCalendar
                                                            ? 'Please use the following calendar to check the availability and select the date and time.'
                                                            : ''
                                                    } `
                                                  : availability(message)
                                                          .showTable &&
                                                      availability(message)
                                                          .hasAvailableDates
                                                    ? 'Some of the dates you have selected are unavailable. If you want to proceed with the available dates click submit.'
                                                    : availability(message)
                                                            .showTable &&
                                                        !availability(message)
                                                            .hasAvailableDates
                                                      ? 'None of the dates you have selected are available. You can select dates from the following calendar and click submit.'
                                                      : message.message}
                                        </Typography>
                                    </Box>
                                    <Typography
                                        variant='subtitle2'
                                        color='textSecondary'
                                        sx={{
                                            fontSize: '10px',
                                            padding: '5px',
                                        }}
                                    >
                                        {message?.sender === '7DAY Assistant'
                                            ? message?.sender
                                            : data?.details?.user?.firstName}
                                    </Typography>
                                </>
                            )}

                            {availability(message).showTable &&
                                availability(message).availabilityCount > 1 && (
                                    <Grid
                                        sx={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                        }}
                                    >
                                        {
                                            <Grid
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: '1000px',
                                                }}
                                            >
                                                <AIHistoryAvailabilityTable
                                                    data={
                                                        JSON.parse(
                                                            message.message,
                                                        ).availability || []
                                                    }
                                                />
                                            </Grid>
                                        }
                                    </Grid>
                                )}

                            {showExperiencesList(message) &&
                                message.experiences &&
                                !isFetchingExperiences && (
                                    <>
                                        {message.experiences.length < 8 ? (
                                            <Grid
                                                container
                                                spacing={4}
                                                columns={60}
                                                sx={{
                                                    flexGrow: 1,
                                                    width: '100%',
                                                    display: 'flex',
                                                }}
                                            >
                                                <ExperiencesListAll
                                                    experiences={
                                                        message.experiences
                                                    }
                                                    visitType=''
                                                    component='aiGuestReservation'
                                                />{' '}
                                            </Grid>
                                        ) : (
                                            <Card
                                                sx={{
                                                    pt: 5,
                                                    pl: 5,
                                                    pb: 5,
                                                    maxHeight: '500px',
                                                    width: '100%',
                                                    overflow: 'auto',
                                                }}
                                            >
                                                <Grid
                                                    container
                                                    spacing={4}
                                                    columns={60}
                                                    sx={{
                                                        flexGrow: 1,

                                                        width: '100%',
                                                        display: 'flex',
                                                    }}
                                                >
                                                    <ExperiencesListAll
                                                        experiences={
                                                            message.experiences
                                                        }
                                                        visitType=''
                                                        component='aiGuestReservation'
                                                    />{' '}
                                                </Grid>{' '}
                                            </Card>
                                        )}
                                    </>
                                )}
                        </Box>
                    );
                })}
            </Stack>
        </Grid>
    );
}
